<template>
  <Drawer
    custom-class="pg-medical-excelAdd"
    :title="title"
    :visible="showDrawer"
    :size="size"
    :before-close="onCancel"
    @close="close"
    @closed="closed"
    @open="init"
    :wrapperClosable="false"
    :transfer="true"
  >
    <div class="flex flex-v" style="height: 100%">
      <div class="excelAdd_content flex flex-v flex-1">
        <p class="margin-bottom-10 flex-shrink0">请选择需要粘贴的列（勾选的先后决定列顺序）</p>
        <div class="flex flex-wrap excelAdd_content-checkGroup flex-shrink0 margin-bottom-10">
          <PgCheckbox
            v-for="(op, index) in checkboxOptions"
            :key="index + '_excelCheckbox'"
            v-model="op.checked"
            :disabled="op.disabled"
            :text="op.name"
            @change="(checked) => checkboxOptionsCurrentCheck(checked, op)"
          ></PgCheckbox>
        </div>
        <p class="flex-shrink0">
          <span
            v-for="(op, index) in checkedOptions"
            class="margin-right-10"
            :key="index + '_excelChecked'"
            >{{ op.name }}</span
          >
        </p>
        <PgInput
          type="textarea"
          style="flex: auto"
          v-model="contentData"
          :placeholder="textAreaPlaceholder"
        ></PgInput>
        <p class="flex-shrink0">共{{ contentDataRow.length }}行</p>
      </div>
      <div class="excelAdd_copyStartRow flex-shrink0" v-if="!hideExcelRowIndex">
        请输入内容粘贴起始行（0代表第一行之前，最大不可超过已添加商品行数,当前商品行数为：{{
          maxRowIndex
        }}）
        <p class="margin-top-5 flex flex-align-center">
          第
          <PgInputNumber
            :disabled="maxRowIndex == 0"
            controls-position="right"
            v-model="rowIndex"
            :min="0"
            :max="maxRowIndex"
            style="width: 108px; margin: 0 5px"
          ></PgInputNumber>
          行
        </p>
      </div>
      <div class="excelAdd_footer flex-shrink0">
        <el-button
          round
          type="primary"
          @click="setCopyData('on-ok')"
          :disabled="contentDataRow.length <= 0 || checkedOptions.length <= 0"
          >确定并关闭</el-button
        >
        <el-button
          round
          type="primary"
          @click="setCopyData('on-ok-and-continue')"
          :disabled="contentDataRow.length <= 0 || checkedOptions.length <= 0"
          >确定并继续</el-button
        >
      </div>
    </div>
  </Drawer>
</template>
<script setup>
// vue
import { ref, computed, toRef } from 'vue'
import { useRoute } from 'vue-router/composables'
// 组件
import { Drawer } from 'element-ui'
import { pgMessage } from '../../message/index'
import { PgCheckbox } from '../../checkbox'
// hook
import { useFlashAddMedical } from '../hook/use-flash-add'
import { useDrawerPack } from '../../../hooks/index'
//utils

const props = defineProps({
  title: {
    type: String,
    default: '通过Excel复制添加商品',
  },
  //侧滑宽度
  size: {
    type: [String, Number],
    default: 600,
  },
  // 配置复选框
  options: Array,
  //   options= {
  //       code: 'code', // 复选框-code
  //       name: '商品编码', // 复选框-名称
  //       disabled: true, // 复选框-是否禁用
  //       checked: true, // 复选框-默认选中
  //       effect: ['insurance'], // 复选框-关联字段（比如选中code 就不允许选择insurance字段了，目前仅支持这个关联字段不允许选中，如果需要可以扩展其他字段 做一个关联选中的功能）
  //       required: true,// 是否必填-仅用于提点击底部按钮时进行判断
  //       request: true, // 若配置该属性表示需要将值放入请求接口中
  //     },
  //     {
  //       code: 'insurance',
  //       name: '医保编码',
  //       effect: ['rate', 'amount'], // 关联字段可以配置多个
  //       required: true, // 此时如果code已经选中 ，则insurance就不能被选择了，但是此时他又是必填，提交时仅根据required判断会有问题，因此判断时，代码会根据他的disabled的状态过滤
  //     },
  //    {
  //       code: 'amount',
  //       name: '数量',
  //     },
  //   隐藏粘贴行数
  hideExcelRowIndex: {
    type: Boolean,
    default: false,
  },
  maxRowIndex: {
    type: Number,
    default: 10,
  },
  visible: {
    type: Boolean,
    default: false,
  },
  onOk: Function,
  //isRequest为true时，不管粘贴的列中有没有都将参数进行封装， 否则仅封装粘贴了的列
  isRequest: {
    type: Boolean,
    default: true,
  },
  textAreaPlaceholder: {
    type: String,
    default: '请从Excel表复制表列内容粘贴至此。',
  },
  // 是否允许传递空选项
  allowEmpty: {
    type: Boolean,
    default: false,
  },
})

// -----------------------------hook-------------------------------
const emit = defineEmits(['on-cancel', 'update:visible', 'close', 'closed', 'on-ok'])
const { close, closed, showDrawer, onCancel, closeDrawer } = useDrawerPack(
  toRef(props, 'visible'),
  emit
)

// 获取公共方法
const { emitData } = useFlashAddMedical(emit)
const route = useRoute()

// ------------处理勾选列部分--------------------
const checkedOptions = ref([])
const checkboxOptions = ref([])

const init = () => {
  contentData.value = ''
  rowIndex.value = ref(props.maxRowIndex ?? 0)
  // 初始化选中状态
  const catchOptions = localStorage.getItem(`${route.name}_pg-medical-excelAddOptions`)
  let optionsConvert = []
  if (catchOptions) {
    optionsConvert = JSON.parse(catchOptions)
    if (
      optionsConvert.length !== props.options.length ||
      optionsConvert.some((item) => props.options.every((im) => item.code !== im.code))
    ) {
      optionsConvert = props.options
    }
  } else {
    optionsConvert = props.options
  }
  checkedOptions.value = []
  checkboxOptions.value = []
  optionsConvert.forEach((op) => {
    if (op.checked == true) checkedOptions.value.push(op)
    checkboxOptions.value.push(op)
  })

  // 循环处理 如果某个选项有effect字段，说明当前选项选中后，effect中的字段是不允许选中与编辑了
  checkboxOptions.value.forEach((op) => {
    if (op.effect && op.checked) {
      checkboxOptions.value.forEach((co) => {
        if (op.effect.includes(co.code)) {
          co.checked = false
          co.disabled = true
        }
      })
    }
  })
}

// 选中变化时
const checkboxOptionsCurrentCheck = (checked, option) => {
  for (var co of checkboxOptions.value) {
    //处理当前选中值影响的字段
    if (option.effect && option.effect.includes(co.code)) {
      co.checked = false // 被操作后，将影响的值置为未选中
      co.disabled = checked ? true : false // 选中的，将影响的值置置为不可选中
      setCheckedOptions(co.checked, co)
    }
  }

  // 选中时，将当前选中值加入选中列表
  setCheckedOptions(checked, option)
}

// 处理checkedOptions中的值
const setCheckedOptions = (checked, option) => {
  const index = checkedOptions.value.findIndex((co) => co.code == option.code)
  if (index > -1) checkedOptions.value.splice(index, 1)
  if (checked) checkedOptions.value.push(option)
}

// ---------------粘贴的textare处理----------------
// 当前粘贴的内容
const contentData = ref('')
// 显示粘贴了多少行
const contentDataRow = computed(() => {
  if (!contentData.value) return []
  else {
    // 过滤那些空行
    return contentData.value.split('\n').filter((im) => im)
  }
})

//  -----------------处理粘贴起始行-----------------------------
const rowIndex = ref(0)

// ------------------------其他------------------------------------------------
const beforeSetCopyData = (type) => {
  // 1.判断必填字段
  // 找到 复选框选项中必填的字段 并且 disabled：为false 的值（请看props中options的insurance字段注释信息）
  // 此时如果code已经选中 ，则insurance就不能被选择了，但是此时他又是必填，提交时仅根据required判断会有问题，因此判断时，代码会根据他的disabled的状态过滤
  // 如果他是disabled 并且没有选中，那么就说明这个字段真的是没有必填了
  const requiredCheckOptions = checkboxOptions.value.filter(
    (im) => im.required && !im.disabled && !im.checked
  )
  if (requiredCheckOptions.length > 0) {
    //找到已经选择的code
    const tempCheckedOptions = checkedOptions.value.map((im) => im.code)
    // 判断是否已经选择的里面没有必填字段
    const lackRequiredOptions = requiredCheckOptions.filter(
      (im) => !tempCheckedOptions.includes(im.code)
    )
    if (lackRequiredOptions.length > 0) {
      pgMessage.warning(
        `${lackRequiredOptions.map((im) => im.name).join(',')} 为必选，请勾选并补充信息后再提交`
      )
      return false
    }
  }
  // 2. 判断选择的粘贴列 与 粘贴的内容 列数是否一致
  // tempContentData的格式是二维数组
  //     [
  //     [
  //         "11223553",
  //         "1"
  //     ],
  //     [
  //         "220036D",
  //         "2"
  //     ]
  // ]

  const tempContentData = contentDataRow.value.map((im) => im.split('\t').filter((i) => i))
  let res = tempContentData.some((content) => content.length !== checkedOptions.value.length)

  if (res && !props.allowEmpty) {
    pgMessage.warning('粘贴的内容列数与允许粘贴的列数不符！请核对后再提交。')
    return false
  }

  // 3.组装传递数据
  // 将选择的列 与 粘贴的内容 对应起来，需要变成这样的结构
  //     {
  //     "code": [
  //         "11223553",
  //         "220036D"
  //     ],
  //     "amountDisplay": [
  //         "1",
  //         "2"
  //     ]
  // }
  const tempCopyData = {}
  const dataOption = {}
  // 第一步： 把需要粘贴的列，当成tempCopyData的属性，放进去
  checkedOptions.value.forEach((im) => {
    tempCopyData[im.code] = []
    dataOption[im.code] = { type: im.request ? 'request' : '', value: [] }
  })
  //  第二步：循环tempContentData 按照顺序放进tempCopyData中
  tempContentData.forEach((imArr) => {
    // im 是个数组
    //     [
    //         "11223553",
    //         "1"
    //     ]
    imArr.forEach((im, index) => {
      tempCopyData[checkedOptions.value[index].code].push(im)
      dataOption[checkedOptions.value[index].code].value.push(im)
    })
  })

  // 需要 对当前选中值进行保存，保证下次打开，还是打开时，还是打开时的选中值
  localStorage.setItem(
    `${route.name}_pg-medical-excelAddOptions`,
    JSON.stringify(checkboxOptions.value)
  )
  // 这个格式， 是老组件这样传递的  其他处理逻辑，将会写一个特殊的hook 最后进行判断，组件这里我们只传递值，不做特殊的字段处理
  const param = {
    data: tempCopyData, // 仅包含勾选的key和值 如： {code: [value1,value2]}
    dataOption, // 包含是否需要将key放在请求参数中， 如： {code: {type: 'request', value: [value1,value2]}}
    type: Object.keys(tempCopyData), // 粘贴的列code}
    drawerCloseOptionType: type, // 是按钮操作的类型  on-ok-and-continue： 确认并继续 on-ok: 确认并关闭 由于选择数据后需要进行非常多的特殊处理 不成功直接关闭侧滑体验很不好
    index: !props.hideExcelRowIndex ? rowIndex.value : props.maxRowIndex, //  如果有粘贴起始行功能 则增加index参数
    total: contentDataRow.value.length, // 总共粘贴了几行
  }
  // 需要放入请求中的参数, 当isRequest为true时，不管粘贴的列中有没有都将参数进行封装， 否则仅封装粘贴了的列
  if (props.isRequest) {
    param.requestData = checkboxOptions.value.reduce((pre, cur) => {
      if (cur.request) {
        pre[cur.code] = param.dataOption[cur.code]?.value
      }
      return pre
    }, {})
  } else {
    param.requestData = param.type.reduce((pre, cur) => {
      if (param.dataOption[cur].type === 'request') {
        pre[cur] = param.dataOption[cur].value
      }
      return pre
    }, {})
  }

  return param
}

const setCopyData = (type) => {
  const param = beforeSetCopyData(type)
  if (!param) return false
  if (props.onOk) {
    props.onOk({ ...param, close: closeDrawer })
    return
  }
  emit(type, param)
  emitData(param)
  if (type == 'on-ok') {
    closeDrawer()
  }
}

defineExpose({
  open: () => {
    showDrawer.value = true
  },
  close,
})
</script>
<style lang="scss">
@import '../style/drawer-excel-add.scss';
</style>
